import { render, staticRenderFns } from "./ReportFunnel.vue?vue&type=template&id=bf928ac2&scoped=true"
import script from "./ReportFunnel.vue?vue&type=script&lang=js"
export * from "./ReportFunnel.vue?vue&type=script&lang=js"
import style0 from "./ReportFunnel.vue?vue&type=style&index=0&id=bf928ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf928ac2",
  null
  
)

export default component.exports